import { css } from "@emotion/react";
import { useProductDetailsState } from "../../../hooks/useProductDetailsState";

//------------------------------------------------------------------------------------
/* ItemNo */
export const ItemNoField = () => {
	const productDetailsState = useProductDetailsState();

	return (
		<div
			css={css`
                padding: .1rem;
            `}
		>
			# {productDetailsState.get().product?.InventoryNo}
		</div>
	);
};
